import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, enumField, DateField } from './util';

export enum TournamentStageStatuses {
  open,
  in_progress,
  closed
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    date: 'date',
    tournament_id: 'tournamentId',
    status: 'status',
  },
  relation: {
    date: DateField,
    status: enumField(TournamentStageStatuses)
  }
})
export class TournamentStage extends BaseModel {
  id: number;
  name: string;
  date: Date;
  tournamentId: number;
  status: TournamentStageStatuses;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
